// extracted by mini-css-extract-plugin
module.exports = {"block":"SelectWrap_block__2jOvL","title":"SelectWrap_title__wyuY0","input":"SelectWrap_input__2r3YE"};